import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Bg, BoxContainer, Underline } from "../../Components/Styles/PageStyles";
import Navbar from "../../Components/Navbar";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { useTranslation } from "react-i18next";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import Table from "../../Components/PartnerWiseTenants/Table";
import moment from "moment";
import {
    FieldWrapper,
    InputGroup,
    Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";

const PartnerWiseTenants = ()=>{

    const user = useSelector((state)=> state.UserReducer.user);
    const [apiData, setApiData] = useState();
    const [selectedData, setSelectedData] = useState();
    const {t} = useTranslation();
    const [startDate, setStartDate] = useState(
            moment(new Date()).format("YYYY-MM-DD") 
        );

    const initialValues = {
            name: "",
            startDate: moment(new Date()).format("YYYY-MM-DD"),
        };    

    const fetchFunction = async()=>{
        const body = new FormData();
        body.append("date", startDate);
        return await axios.post(`${Config.apiUrl}/getpartnertenant`, body ,{
            headers: {
                authorization: "Bearer " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
    });
    }

    const onPartnerSuccess = (res)=>{
        if(res.data.data == "NOK" || res.data.data == false) error = true
        setApiData(res.data);
    }

    const onPartnerError = (data)=>{}

    const {
        isLoading: isPartnerLoading,
        mutate: getPartnerMutate,
        error,
        data
    }= useMutation( fetchFunction,{
        onSuccess: onPartnerSuccess,
        onError: onPartnerError,
    })


    useEffect(() => {
    const handler = setTimeout(() => {
            getPartnerMutate();
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [ startDate]);

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
        };
        setStartDate(newValues.startDate);
        // getPartnerMutate();
    };
    
    
    return(
        <>
          <Bg
            style={{
                backgroundImage: `url(${Images.BeamsBg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "top left",
                height: "100vh",
            }}
          >
            <Navbar />
            <BoxContainer>
                <div className="flex w-full justify-between items-center">
                    <div>
                        <Title>
                            {t("Partner Wise Tenants")}
                        </Title>
                        <Underline />
                    </div>
                </div>

                <div className="flex w-full justify-between items-center">
                <Filters
                    submitHandler={submitHandler}
                    initialValues={initialValues}
                    InitialLoading={isPartnerLoading}
                    user={user}
                    t={t}
                />
            </div>

                {!error && !isPartnerLoading && data && (
                <TableWrapper>
                <Table
                    ApiData={apiData?.data}
                    setSelectedData={setSelectedData}
                    userType={user.userType}
                    selectedData={selectedData}
                />
                {(error || apiData?.msg == "No data found") && !isPartnerLoading && (
                    <NotFoundModel />
                )}
                </TableWrapper>
            )}

            {isPartnerLoading && <Loading />}
            </BoxContainer>
          </Bg>
        
        </>
    )
}

const Filters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    t,
}) => {
    const today = moment().format("YYYY-MM-DD");
    const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD");

    return (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
            <Form className="w-full">
                <FilterContainer>
                    <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
                        <div className="flex items-end gap-2">
                            <InputGroup className="max-w-[200px]">
                                <Label htmlFor="startDate">{("Date")}:</Label>
                                <FieldWrapper className="h-10">
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-3.5"
                                    />
                                    <Field
                                        type="date"
                                        name="startDate"
                                        id="startDate"
                                        className="ml-1"
                                        min={firstDayOfMonth}
                                        max={today}
                                    />
                                </FieldWrapper>
                            </InputGroup>
                        </div>
                        <ApplyBtn disabled={InitialLoading} type="submit">
                            {t("Date_filter")}
                        </ApplyBtn>
                    </div>
                </FilterContainer>
            </Form>
        </Formik>
    );
};

const Title = tw.h1`text-xl w-full text-gray-800 whitespace-nowrap font-medium flex justift-center`
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default PartnerWiseTenants;


